<template>
   <div id="home-main-container" class="bg-white q-pa-md">
      <!-- Header Section -->
      <PageHeader title="Variable Explorer" />
      <div id="main-container">
         <!-- Installation Instructions or Stacked Graphs -->
         <VariableSnapshotCard :loading="loading" />
      </div>
   </div>
</template>
<script setup lang="ts">
// Imports
import { useProjectStore } from "../stores"
import { useAnalyticsStore } from "@/stores/analyticsStore"
import { onMounted, ref, watch, nextTick, toRefs } from "vue"
import VariableSnapshotCard from "@components/variable-snapshot/VariableSnapshotCard.vue"
import PageHeader from "@/components/common/PageHeader.vue"
import { callWithLoading } from "@utils/callWithLoading"
import { useQuasar } from "quasar"
import { useTour } from "@/composables/useTour"
import { variableExplorerTour } from "@/tours/variableExplorerTour"

const $q = useQuasar()
// Stores
const projectStore = useProjectStore()
const analyticsStore = useAnalyticsStore()

// Destructure utmSource from analytics store
const { utmSource } = toRefs(analyticsStore)

// Tour setup
const { autoStartTour } = useTour(variableExplorerTour)

const loading = ref(false)

const getVariablesByProjectIdWithLoading = async () => {
   try {
      loading.value = true
      await callWithLoading(projectStore.getVariablesByProjectId, $q)
   } catch (error) {
      loading.value = false
      throw error
   } finally {
      loading.value = false
   }
}

// Lifecycle Hooks
onMounted(async () => {
   await getVariablesByProjectIdWithLoading()
   await nextTick() // Wait for Vue to re-render with the data
   if (projectStore.variables.length > 0) {
      await autoStartTour() // Start the tour if data is present
   }
})

// Watch for UTM source changes
watch(utmSource, async () => {
   await getVariablesByProjectIdWithLoading()
})

// Watch for date range changes from analytics store
watch(
   [() => analyticsStore.start_date, () => analyticsStore.end_date],
   async () => {
      await getVariablesByProjectIdWithLoading()
   },
)
</script>
<style lang="scss" scoped>
#main-container {
   width: 100%;
}
#kpi-container {
   display: flex;
   align-items: center;
   gap: 2em;
   width: 100%;
   padding-top: 1em;
   padding-bottom: 1em;
}
.kpi-card {
   width: 100%;
}
#graphs-container {
   width: 100%;
   display: flex;
   flex-direction: row;
   align-items: center;
   gap: 2em;
}
.graph-card {
   width: 100%;
}

#chips-container {
   display: flex;
   gap: 1em;
}
#conversion-rate-filter-container {
   display: flex;
   gap: 1em;
   // border: 1px solid rgb(160, 160, 160);
   // border-radius: 5px;
   padding: 1em 2em;
}
@media (max-width: 1400px) {
   #dashboard-title {
      margin-bottom: 0.5em;
   }
   .graph-card {
      width: 100%;
   }
   #kpi-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
   }
   #graphs-container {
      flex-direction: column;
   }
   #dropdown-container {
      margin-bottom: 1em;
   }
   #chips-container {
      width: 100%;
   }
}
#home-main-container {
   min-height: 100vh;
}
#intro-paragraph {
   max-width: 800px;
}
</style>
